import { connect } from 'react-redux'

import { getCurrentUser } from '@selectors/data/user_selectors.js'
import { getEmbedKey } from '@selectors/data/embed_key_selectors.js'
import { getEmbedKeyLoadStatus } from '@selectors/ui/timeline_show.js'
import { getEditableColorScheme } from '@selectors/data/color_scheme_selectors.js'
import { loadEmbedKey } from '@actions/embed_key_actions.js'
import { changeEditableColorScheme } from '@actions/color_scheme_actions.js'

import EmbedPaneContent from '../components/embed_pane_content.jsx'

const mapStateToProps = (state, props) => {
  const { signedIn, host, timelineId, isPublished, allowEmbedding } = props
  const embedKey = getEmbedKey(state, { timelineId })
  const embedKeyLoadStatus = getEmbedKeyLoadStatus(state, props)
  const colorScheme = getEditableColorScheme(state, props)
  const currentUser = getCurrentUser(state)
  return {
    currentUser,
    host,
    timelineId,
    isPublished,
    allowEmbedding,
    embedKey,
    embedKeyLoadStatus,
    colorScheme,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loadEmbedKey: function (timelineId) {
      dispatch(loadEmbedKey(timelineId))
    },
    changeEditableColorScheme: function (colorScheme) {
      dispatch(changeEditableColorScheme(colorScheme))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedPaneContent)
